/**
 * @copyright Elmelo Ltd.
 */

import React from 'react'

import { Router } from "@reach/router"

import OfferHome from './home'

import P404 from '../_common/404'

/**
 */
class App_Offer extends React.PureComponent
{
    /**
     */
    // constructor( props )
    // {
    //     super( props )
    // }

    /**
     */
    render()
    {
        return (
            <Router>
                <OfferHome path='offer'/>

                <P404 default />
            </Router>
            )
    }   // render
}   // class App_Offer

/**
 */
export {App_Offer, OfferHome}
